import PropTypes from 'prop-types';
import React, { Component } from 'react';

import ActionMenuOverlay from './overlay';

class ActionMenu extends Component {

  /* Lifecycle */

  constructor(props) {
    super(props);

    this.state = {
      visible: props.visible,
    };

    this.actionMenuButtonHandler = this.actionMenuButtonHandler.bind(this);
    this.closeActionMenu = this.closeActionMenu.bind(this);
    this.listButtonHandler = this.listButtonHandler.bind(this);
  }

  /* Handlers */

  actionMenuButtonHandler(e) {
    e.stopPropagation();

    this.setState({
      visible: !this.state.visible,
    });
  }

  listButtonHandler(e, action) {
    e.stopPropagation();

    this.closeActionMenu();

    if (action && action.name) this.props.actionHandler(action);
  }

  /* Methods */

  closeActionMenu() {
    this.setState({
      visible: false,
    });
  }

  /* Methods */

  render() {
    let content = null;
    let trigger = null;

    const { actions, children, position, customTrigger } = this.props;

    if (customTrigger) {
      trigger = React.cloneElement(children, {
        onClick: this.actionMenuButtonHandler,
      });
    } else {
      trigger = (
        <button
          className="action-menu__trigger button button-bg-white"
          onClick={this.actionMenuButtonHandler}
        >
          {children}
        </button>
      );
    }

    if (this.state.visible) {
      content = (
        <ActionMenuOverlay
          actions={actions}
          listButtonHandler={this.listButtonHandler}
          onClose={this.closeActionMenu}
          position={position}
        />
    );
    }

    return (
      <div className="action-menu">
        {trigger}
        {content}
      </div>
    );
  }
}

ActionMenu.defaultProps = {
  position: 'top-right',
  visible: false,
};

ActionMenu.propTypes = {
  actionHandler: PropTypes.func,
  actions: PropTypes.array,
  children: PropTypes.node,
  customTrigger: PropTypes.bool,
  position: PropTypes.string,
  visible: PropTypes.bool,
};

export default ActionMenu;



// WEBPACK FOOTER //
// ./js/components/action-menu/index.jsx